import React, { useState, useEffect } from 'react';
import * as _ from 'lodash';
import Moment from 'moment';

// 分割画面の状態
import masterSlideLoader from '../utilities/masterSlideLoader';
import EventMg, { EventType } from '../utilities/EventManager';
import {
  USER_ROLES,
  AGENCY_REGISTRATION_APPLICATION_PAGE,
  CHECK_EXPIRATION_DURATION,
  ENV_VARS,
  ZENDESK_URL_NONE,
  CALL_FROM_PAGE,
} from '../utilities/constants';
import { messageUtility } from '../utilities/messageUtility';
import { isTargetRoleId } from '../utilities/roleUtility';
import { UserProfileService } from '../services/UserProfiles';
import Auth from '../components/Auth';
import Tippy, { createPopperBoundaryProps } from '../components/ReactTippy';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionsService from '../services/Sessions';
import * as StringUtil from '../utilities/stringUtil';
import SessionStorageService from '../../src/services/utilities/SessionStorageService';
import AuthProvider from '../utilities/authProvider';
import { FieldService } from '../services/Fields';
import { CompanyService } from '../services/Companies';
import { UserAgencyService } from '../services/UserAgency';
import { WorkersApi } from '../services/workers/WorkersApi';
import { hasRoanPermission } from '../utilities/companyUserPermissionUtil';
import { changeFieldWriteStorage } from '../utilities/fieldUtil';
import { getGreenFileSystemUrl, getZendeskUrl } from '../utilities/commonUtil';
import { BellIcon } from './icons/BellIcon';
import { AgencyCompaniesIcon } from '../components/icons/AgencyCompaniesIcon';
import { AgencyRegistrationApplicationsIcon } from '../components/icons/AgencyRegistrationApplicationsIcon';
import { AgentOriginsIcon } from '../components/icons/AgentOriginsIcon';
import Information from '../components/modals/common/Information';
import {
  setCompanyBranchNameForGTM,
  setCompanyNameForGTM,
} from '../utilities/gtm';
import { FIELD_TREE_EVENTS } from './FieldTreeEvents';
Moment.locale('ja');

const VIEWPORT_BOUNDARY = createPopperBoundaryProps('viewport');

export default class MasterNavi extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // メニューの状態
      railnavi: SessionStorageService.isOpeningMasterMenu(), // 開閉状態
      prev_railnavi: SessionStorageService.isOpeningFunctionMenu(),
      roleId: LocalStorageService.getRoleId(), // ユーザーロール
      userId: LocalStorageService.getUserId(),
      companyId: SessionStorageService.getCompanyId(),
      fieldName: '現場未選択', // 選択中の現場名称,
      darkListScrollHeight: '100vh - 190px',
      expirationCompany: {
        has_expired_company_safety: false,
        has_expired_company_branch_safety: false,
        has_about_to_expire_company_safety: false,
        has_about_to_expire_company_branch_safety: false,
      },
      expirationWorkers: {
        has_expired: false,
        has_about_to_expire: false,
      },
      expirationAgency: {
        has_expired: false,
        has_about_to_expire: false,
        has_foreign_construction_workers: false,
      },
      showHelpCenterDialog: false,
      inconsistencyStatus: {
        mismatching_status_flag: false,
        unconfirmed_status_flag: false,
      },
    };
    this.footerListRef = React.createRef();

    EventMg.addEventListener(EventType.FULL_SCREAN_MODE, fullscrean => {
      this.setState({ railnavi: !fullscrean });
      EventMg.trigger(EventType.LAYOUT_UPDATE, {});
    });
  }

  componentWillMount() {
    this.setUserProfileService();
  }

  setUserProfileService() {
    const userId = LocalStorageService.getItem('user_id');
    UserProfileService.show(userId, {}).then(response => {
      if (!response.result) {
        return;
      }

      const sessionPrimeCompanyId = SessionStorageService.getItem(
        'sessionPartnerCompanyIdOfPrimeCompany'
      );
      let company;
      if (sessionPrimeCompanyId) {
        company = _.find(response.data.entities.company, company => {
          return String(company.id) === sessionPrimeCompanyId;
        });
      }
      if (!company) {
        SessionStorageService.removeItem('sessionPrimeCompanyId');
        SessionStorageService.removeItem(
          'sessionPartnerCompanyIdOfPrimeCompany'
        );
        company = response.data.entities.company[0];
      }
      const companyName = _.size(company) > 0 ? company.name : '';
      let iconImage = response.data.entities.company_icon_image_url;
      iconImage = !_.isNull(iconImage) ? iconImage : '';
      const useOutputCsvProcessingFlg =
        response.data.entities.user_profile.use_output_csv_processing_flg;

      setCompanyNameForGTM(companyName);
      setCompanyBranchNameForGTM(
        _.get(response, 'data.entities.company_branch[0].name', '')
      );
      this.setState({ companyName, iconImage, useOutputCsvProcessingFlg });
    });
  }

  getExpiration = async () => {
    const lastCheckedTimeOfExpiration = SessionStorageService.getLastCheckedTimeOfExpiration();
    const now = Moment();
    if (lastCheckedTimeOfExpiration) {
      if (
        now.diff(Moment(lastCheckedTimeOfExpiration), 'minutes') <
        CHECK_EXPIRATION_DURATION
      ) {
        return null;
      }
    }
    const hasSafetyPermission = await hasRoanPermission(this.state.companyId);
    if (
      isTargetRoleId(
        [USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.partner],
        this.state.roleId
      )
    ) {
      // 会社情報から期限期間情報を取得する
      await CompanyService.expirations(this.state.companyId).then(response => {
        if (!response.result) {
          return;
        }
        this.setState({
          expirationCompany: {
            ...this.state.expirationCompany,
            ...response.data.entities.company.expiration,
          },
        });
      });
    }
    if (
      isTargetRoleId([USER_ROLES.partner], this.state.roleId) &&
      hasSafetyPermission
    ) {
      // 作業員一覧から期限期間情報を取得する
      await WorkersApi.getExpirationWorkers(this.state.companyId).then(
        response => {
          if (!response.result) {
            return;
          }
          this.setState({
            expirationWorkers: {
              ...this.state.expirationWorkers,
              ...response.data.entities.workers.expiration,
            },
          });
        }
      );
    }
    if (isTargetRoleId([USER_ROLES.partner], this.state.roleId)) {
      this.getRankConsitencyStatus();
      // 代行先一覧から期限期間情報を取得する
      let expirationAgency = {
        has_about_to_expire: false,
        has_expired: false,
        has_foreign_construction_workers: false,
      };
      const expiredResult = new Promise((resolve, reject) => {
        UserAgencyService.list({
          selected_partner_company_id: this.state.companyId,
          has_expired: true,
          call_from: CALL_FROM_PAGE.MASTER_NAVIGATION,
          status: 2,
          limit: 1,
        }).then(response => {
          if (!response.result) {
            reject(new Error('期限切れ情報が取得できませんでした'));
          } else {
            resolve(response.data.entities.companies);
          }
        });
      });
      const expiringResult = new Promise((resolve, reject) => {
        UserAgencyService.list({
          selected_partner_company_id: this.state.companyId,
          has_about_to_expire: true,
          call_from: CALL_FROM_PAGE.MASTER_NAVIGATION,
          status: 2,
          limit: 1,
        }).then(response => {
          if (!response.result) {
            reject(new Error('期限切れ間近情報が取得できませんでした'));
          } else {
            resolve(response.data.entities.companies);
          }
        });
      });
      const foreignConstructionWorkerResult = new Promise((resolve, reject) => {
        UserAgencyService.list({
          selected_partner_company_id: this.state.companyId,
          has_foreign_construction_workers: true,
          call_from: CALL_FROM_PAGE.MASTER_NAVIGATION,
          status: 2,
          limit: 1,
        }).then(response => {
          if (!response.result) {
            reject(new Error(messageUtility.getMessage('E-001-108')));
          } else {
            resolve(response.data.entities.companies);
          }
        });
      });
      Promise.all([
        expiredResult,
        expiringResult,
        foreignConstructionWorkerResult,
      ])
        .then(results => {
          // 期限あり情報
          if (!_.isEmpty(results[0])) {
            expirationAgency.has_expired = true;
          }
          // 期限間近あり情報
          if (!_.isEmpty(results[1])) {
            expirationAgency.has_about_to_expire = true;
          }
          if (!_.isEmpty(results[2])) {
            expirationAgency.has_foreign_construction_workers = true;
          }
          this.setState({ expirationAgency });
        })
        .catch(error => {
          console.error(error.message);
        })
        .finally(() => {
          SessionStorageService.setLastCheckedTimeOfExpiration(Moment());
        });
    }
  };
  getRankConsitencyStatus = () => {
    WorkersApi.getRankConsitencyStatus(this.state.companyId).then(response => {
      if (!response.result) {
        return;
      }
      this.setState({
        inconsistencyStatus: _.get(response, 'data.entities.workers'),
      });
    });
  };

  componentDidMount() {
    SessionStorageService.removeLastCheckedTimeOfExpiration();
    this.getURLParam();
    this.getExpiration();
    this.getSelectField().then(() => {
      EventMg.addEventListener(EventType.CONFERENCE_MODE, conference => {
        if (conference) {
          this.setState({
            railnavi: false,
            prev_railnavi: this.state.railnavi,
          });
        } else {
          this.setState({
            railnavi: this.state.prev_railnavi,
          });
        }
        EventMg.trigger(EventType.LAYOUT_UPDATE, {});
      });
      EventMg.addEventListener(EventType.HIDE_MASTER_MENU, () => {
        this.setState({ railnavi: false });
        EventMg.trigger(EventType.LAYOUT_UPDATE, {});
      });
      EventMg.addEventListener(EventType.FETCH_CONSISTENCY_STATUS, () => {
        this.getRankConsitencyStatus();
      });
    });
    const fieldId = SessionStorageService.getItem('field_id');
    if (fieldId) {
      FieldService.info(fieldId)
        .then(response => {
          if (!response.result) {
            console.error(response);
          }
          this.setState({ fieldName: response.data.entities.field.name });
        })
        .catch(e => {
          console.error(e);
        });
    }

    this.setDarkListScrollHeight();
    window.addEventListener(
      'resize',
      _.debounce(this.setDarkListScrollHeight, 500)
    );
  }

  componentWillUnmount() {
    EventMg.deleteEvent(EventType.FETCH_CONSISTENCY_STATUS);
    window.removeEventListener(
      'resize',
      _.debounce(this.setDarkListScrollHeight, 300)
    );
  }

  setDarkListScrollHeight = () => {
    const { innerHeight } = window;
    let footerListHeight = `190`;
    if (this.footerListRef.current && this.footerListRef.current) {
      footerListHeight = _.round(
        this.footerListRef.current.getBoundingClientRect().height
      );
    }

    this.setState({
      darkListScrollHeight: `calc(${innerHeight}px - ${footerListHeight}px)`,
    });
  };

  /**
   * サイドメニューの開閉
   * @param {boolean} openingFlag: true:開く、false:閉じる
   */
  naviStatus(openingFlag) {
    this.setState({ railnavi: openingFlag });
    SessionStorageService.setOpeningMasterMenu(openingFlag);
    EventMg.trigger(EventType.LAYOUT_UPDATE);
  }

  //労務安全 → 調整会議の遷移時に選択現場を取得
  async getSelectField() {
    let fieldId = SessionStorageService.getItem('field_id');
    if (StringUtil.isNullOrEmpty(fieldId)) {
      return;
    }
    //現場情報取得(共通API)
    await SessionsService.getfield().then(async response => {
      if (!response.result) {
        return;
      }
      // 共通APIで保持している現場ID（労安等で現場変更された場合の同期）
      let currentFieldId;
      /**
       * currentFieldIdがundefined is not an objectになるケースが
       * エラーログに複数あったため対策
       */
      try {
        currentFieldId = response.data.entities.field_id;
      } catch (e) {
        console.error(e.message);
        return;
      }
      if (parseInt(currentFieldId) !== parseInt(fieldId)) {
        if (StringUtil.isNullOrEmpty(currentFieldId)) {
          return;
        }
        return FieldService.info(currentFieldId)
          .then(async response => {
            if (!response.result) {
              console.error(
                'masterNavi.js',
                'getSelectField',
                'FieldService.info !response.result',
                response
              );
              return;
            }
            const result = await changeFieldWriteStorage(
              response.data.entities.field
            );
            document.location.reload(true);
            return result;
          })
          .catch(error => {
            console.error(
              'masterNavi.js',
              'getSelectField',
              'FieldService.info catch',
              error
            );
          });
      }
    });
  }

  /**
   * @description 労務安全 → 調整会議の遷移時に戻り先労務安全URLを設定
   */
  getURLParam() {
    const queryParamString = location.search.substring(1);
    // URL末尾の「?__sender=greenfile&__callback=XXXX&param1=123&param2=abc」の形式の
    // クエリパラメータを取得する
    // queryParamString には先頭の'?'は含まれない。

    // console.log(
    //   'masterNavi.js getURLParam',
    //   queryParamString === '',
    //   queryParamString
    // );

    const domainGreenFile = process.env.REACT_APP_GREENFILE_URL;

    const greenFileSystemUrl = getGreenFileSystemUrl(
      domainGreenFile,
      queryParamString
    );

    if (_.isUndefined(greenFileSystemUrl)) {
      return;
    }

    SessionStorageService.setItem('url', greenFileSystemUrl);
  }

  toggleShowHelpCenterDialog = () => {
    this.setState({
      showHelpCenterDialog: !this.state.showHelpCenterDialog,
    });
  };

  render() {
    // スマホがなんらかの理由でPC版ページを読み込もうとした場合に
    // ここで再ログイン処理を行って誤動作を防止している
    const ua = window.navigator.userAgent.toLowerCase();
    const spWebPageFlag =
      ua.includes('iphone') ||
      (ua.includes('android') && ua.includes('mobile'));
    if (spWebPageFlag) {
      AuthProvider.instance.userManager.signinRedirect();
      return;
    }

    const railside = classname => {
      return this.state.railnavi ? `${classname} show` : classname;
    };
    const isFieldSelected = SessionStorageService.getItem('field_id');
    const styleFieldTreeMenu = `${
      isFieldSelected ? 'enable' : 'disable'
    } line-list line-list--darklist`;
    const joiningFlag = SessionStorageService.isCommonPartnerCompany();
    const styleWorkersMenu = `${
      joiningFlag ? 'enable' : 'disable'
    } line-list line-list--darklist`;
    return (
      <div id='master-navi' className={railside('rail__side')}>
        {/* 開閉ボタン */}
        <div className='rail__master-navi'>
          <div
            id='master-navi-btn-show'
            className='btn-rail-master-navi btn--rail__show'
            onClick={() => {
              this.naviStatus(true);
            }}
          >
            <i className='i-warrow-right i-2x' alt='開く' aria-hidden='true' />
          </div>
          <div
            id='master-navi-btn-hide'
            className='btn-rail-master-navi btn--rail__hide'
            onClick={() => {
              this.naviStatus(false);
            }}
          >
            <i className='i-warrow-left i-2x' alt='閉じる' aria-hidden='true' />
          </div>
        </div>
        <div className='rail__menu'>
          <div className='master-navi'>
            <div className='darklist darklist--master-navi'>
              {/* 会社名 */}
              <CompanyName
                iconImage={this.state.iconImage}
                companyName={this.state.companyName}
              />
              {/* 上部メニュー */}
              <div
                className='darklist__scroll'
                style={{ height: this.state.darkListScrollHeight }}
              >
                <div className='darklist__section'>現場情報</div>
                {/* 現場一覧 */}
                <Fields callback={this.getExpiration} />
                {/* 新規現場承認 */}
                <ApproveField callback={this.getExpiration} />
                {/* 新規現場申請 */}
                <RequestField callback={this.getExpiration} />
                {/* 稼働状況 */}
                <WorkSummaries callback={this.getExpiration} />
                {/* 現場体制 (施工体系図) */}
                <FieldTrees
                  callback={this.getExpiration}
                  className={styleFieldTreeMenu}
                  fieldName={this.state.fieldName}
                />
                <div className='darklist__section'>自社情報</div>
                {/* 会社情報 */}
                <CompanyInfo
                  callback={this.getExpiration}
                  roleId={this.state.roleId}
                  expirationCompany={this.state.expirationCompany}
                />
                {/* 役職一覧 */}
                <Positions callback={this.getExpiration} />
                {/* 職種一覧 */}
                <Jobs callback={this.getExpiration} />
                {/* ユーザー一覧 */}
                <Users callback={this.getExpiration} />
                {/* 作業員一覧 */}
                <Workers
                  callback={this.getExpiration}
                  className={styleWorkersMenu}
                  roleId={this.state.roleId}
                  expirationWorkers={this.state.expirationWorkers}
                  inconsistencyStatus={this.state.inconsistencyStatus}
                />
                {/* 一覧表示設定 */}
                <ListSettings callback={this.getExpiration} />
                {/* CSVデータ出力 */}
                <OutputCSV
                  callback={this.getExpiration}
                  isDisplay={this.state.useOutputCsvProcessingFlg}
                />
                <Auth
                  approvedRoles={[
                    USER_ROLES.prime,
                    USER_ROLES.branch,
                    USER_ROLES.manager,
                    USER_ROLES.partner,
                  ]}
                >
                  <div className='darklist__section'>協力会社情報</div>
                </Auth>
                {/* 協力会社一覧 */}
                <PartnerCompanies callback={this.getExpiration} />
                {/* 代行先一覧 */}
                <AgencyCompanies
                  className={styleWorkersMenu}
                  expirationAgency={this.state.expirationAgency}
                  callback={this.getExpiration}
                />
                {/* 代行登録申請一覧*/}
                <AgencyRegistrationApplications
                  className={styleWorkersMenu}
                  callback={this.getExpiration}
                />
                {/* 代行元一覧 */}
                <AgentOrigins
                  className={styleWorkersMenu}
                  callback={this.getExpiration}
                />
              </div>
              {/* 下部メニュー */}
              <div className='master-navi__footer' ref={this.footerListRef}>
                {/* 通知一覧 */}
                <Notices callback={this.getExpiration} />
                {/* ヘルプセンター */}
                <HelpCenter
                  toggleShowHelpCenterDialog={this.toggleShowHelpCenterDialog}
                />
                {/* お客様番号 */}
                <div className='site-footer'>
                  <CustomerNumber userId={this.state.userId} />
                  {/* コピーライト */}
                  <Copyright />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Information
          visible={this.state.showHelpCenterDialog}
          onClose={this.toggleShowHelpCenterDialog}
          title={messageUtility.getMessage('E-000-005-01')}
          message={messageUtility.getMessage('E-000-005-02')}
          buttonText={messageUtility.getMessage('I-000-017')}
          multilineText={true}
          rootClassName={'dialog-md--help-center'}
        />
      </div>
    );
  }
}

const checkShowExitFieldTreeConfirmDialog = callback => {
  if (SessionStorageService.getFieldTreeHasNodeInvited()) {
    EventMg.trigger(FIELD_TREE_EVENTS.SHOW_EXIT_CONFIRM_DIALOG, callback);
    return;
  }
  callback();
};

const showMasterSlideLoader = (...params) => {
  const callback = () => {
    masterSlideLoader.show(...params);
  };
  checkShowExitFieldTreeConfirmDialog(callback);
};

/**
 * 会社名
 * @param iconImage: 会社ロゴ画像
 * @param companyName: 会社名
 * */
const CompanyName = ({ iconImage, companyName }) => {
  return (
    <React.Fragment>
      <div className='company-logo'>
        {!StringUtil.isNullOrUndefinedOrEmptyStr(iconImage) ? (
          <img src={iconImage} className='company-logo_size' alt='' />
        ) : null}
      </div>
      <h2 className='master-navi__title'>{companyName}</h2>
    </React.Fragment>
  );
};

/**
 * 現場一覧
 * */
const Fields = ({ callback }) => {
  return (
    <Auth
      approvedRoles={[
        USER_ROLES.prime,
        USER_ROLES.branch,
        USER_ROLES.manager,
        USER_ROLES.partner,
        USER_ROLES.foreman,
      ]}
    >
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('Fields', { state: { id: 0 } });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-fields' aria-hidden='true' />
          </div>
          現場一覧
        </div>
      </div>
    </Auth>
  );
};

/**
 * 新規現場承認
 * */
const ApproveField = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('FieldRequestList', {
              state: { id: 1 },
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-approve-fields' aria-hidden='true' />
          </div>
          新規現場承認
        </div>
      </div>
    </Auth>
  );
};

/**
 * 新規現場申請
 * */
const RequestField = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.manager]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('FieldRequestList', {
              state: { id: 1 },
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-request-fields' aria-hidden='true' />
          </div>
          新規現場申請
        </div>
      </div>
    </Auth>
  );
};

/**
 * 稼働状況
 * */
const WorkSummaries = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('FieldWorkSummaries', {
              state: {},
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-work-summaries' aria-hidden='true' />
          </div>
          稼働状況
        </div>
      </div>
    </Auth>
  );
};

/**
 * 現場体制 (施工体系図)
 * @param className: クラス名
 * @param fieldName: 現場名
 * */
const FieldTrees = ({ className, fieldName, callback }) => {
  return (
    <Auth
      approvedRoles={[
        USER_ROLES.prime,
        USER_ROLES.branch,
        USER_ROLES.manager,
        USER_ROLES.partner,
      ]}
    >
      <div className='darklist__part'>{fieldName}</div>
      <div className='darklist__item'>
        <div
          className={className}
          onClick={() => {
            callback();
            if (SessionStorageService.getItem('field_id')) {
              // マスター管理メニューから遷移する際には保持している検索条件をクリアする
              SessionStorageService.removeFieldTreeSearchParam();
              masterSlideLoader.show('FieldTreePage', {
                state: { id: 1 },
              });
            }
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-field-trees' aria-hidden='true' />
          </div>
          現場体制 (施工体系図)
        </div>
      </div>
    </Auth>
  );
};

/**
 * 会社情報
 * @param roleId: ロールID
 * */
const CompanyInfo = ({ roleId, expirationCompany, callback }) => {
  const hasExpiration = _.some(expirationCompany);
  let expirationText = '';
  let iconType = '';
  if (
    _.some([
      expirationCompany.has_expired_company_branch_safety,
      expirationCompany.has_expired_company_safety,
    ])
  ) {
    iconType = 'warning';
    expirationText = messageUtility.getMessage('E-001-105');
  } else {
    iconType = 'caution';
    expirationText = messageUtility.getMessage('E-001-106');
  }
  return (
    <Auth
      approvedRoles={[USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.partner]}
    >
      <div className='darklist__item'>
        <Tippy
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[50, 100]}
          placement='bottom'
          followCursor={true}
          html={<div className='darklist__tooltip'>{expirationText}</div>}
          disable={!hasExpiration}
          popperOptions={VIEWPORT_BOUNDARY}
        >
          <div
            className='enable line-list line-list--darklist'
            onClick={() => {
              callback();
              checkShowExitFieldTreeConfirmDialog(() => {
                const slideName =
                  roleId < USER_ROLES.partner.id
                    ? 'PrimeCompanyPreview'
                    : 'CompanyPreview';
                masterSlideLoader.show(slideName, {
                  state: {
                    id: SessionStorageService.getItem(
                      'sessionPartnerCompanyIdOfPrimeCompany'
                    ),
                  },
                });
              });
            }}
          >
            <div className='icon icon--line-list'>
              <i className='i-company' aria-hidden='true' />
            </div>
            会社情報
            {hasExpiration && <WarningIcon color={iconType} />}
          </div>
        </Tippy>
      </div>
    </Auth>
  );
};

/**
 * 役職一覧
 * */
const Positions = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('Positions', {
              state: { id: 1 },
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-positions' aria-hidden='true' />
          </div>
          役職一覧
        </div>
      </div>
    </Auth>
  );
};

/**
 * 職種一覧
 * */
const Jobs = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('Jobs', { state: { id: 1 } });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-jobs' aria-hidden='true' />
          </div>
          職種一覧
        </div>
      </div>
    </Auth>
  );
};

/**
 * ユーザー一覧
 * */
const Users = ({ callback }) => {
  return (
    <Auth
      approvedRoles={[
        USER_ROLES.prime,
        USER_ROLES.branch,
        USER_ROLES.manager,
        USER_ROLES.partner,
        USER_ROLES.foreman,
      ]}
    >
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('Users', { state: { id: 0 } });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-users' aria-hidden='true' />
          </div>
          ユーザー一覧
        </div>
      </div>
    </Auth>
  );
};

/**
 * 一覧表示設定
 * */
const ListSettings = ({ callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('ListSettingsPreview', { state: { id: 0 } });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-list-settings' aria-hidden='true' />
          </div>
          一覧表示設定
        </div>
      </div>
    </Auth>
  );
};

/**
 * 作業員一覧
 * */
const Workers = ({
  className,
  roleId,
  expirationWorkers,
  inconsistencyStatus,
  callback,
}) => {
  const hasExpiration = _.some(expirationWorkers);
  const hasInconsistencyStatus = _.some(inconsistencyStatus);
  let expirationText = '';
  let inconsistencyStatusText = '';
  let iconType = 'caution';
  let foreignConstructionWorkerText = '';
  if (expirationWorkers.has_expired) {
    iconType = 'warning';
    expirationText = messageUtility.getMessage('E-001-105');
  } else if (expirationWorkers.has_about_to_expire) {
    expirationText = messageUtility.getMessage('E-001-106');
  }
  if (expirationWorkers.has_foreign_construction_worker) {
    iconType = 'warning';
    foreignConstructionWorkerText = messageUtility.getMessage('E-001-107');
  }
  if (hasInconsistencyStatus) {
    inconsistencyStatusText = messageUtility.getMessage('W-000-018');

    if (inconsistencyStatus.mismatching_status_flag) {
      iconType = 'warning';
      inconsistencyStatusText = messageUtility.getMessage('W-000-017');
    }
  }

  const renderMessage = () => {
    const messages = [];
    if (expirationText) {
      messages.push(expirationText);
    }
    if (inconsistencyStatusText) {
      messages.push(inconsistencyStatusText);
    }
    if (foreignConstructionWorkerText) {
      messages.push(foreignConstructionWorkerText);
    }

    return (
      <div className='darklist__tooltip'>
        {messages.map((message, index) => (
          <React.Fragment key={index}>
            {messages.length > 1 && '・'}
            {message}
            {index < messages.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <Auth approvedRoles={[USER_ROLES.partner, USER_ROLES.foreman]}>
      <div className='darklist__item'>
        <Tippy
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[50, 100]}
          placement='bottom'
          followCursor={true}
          html={renderMessage()}
          disable={!hasExpiration && !hasInconsistencyStatus}
          popperOptions={VIEWPORT_BOUNDARY}
        >
          <div
            className={className}
            onClick={() => {
              callback();
              checkShowExitFieldTreeConfirmDialog(() => {
                let selectedCompanyId = null;
                if (isTargetRoleId([USER_ROLES.partner], roleId)) {
                  selectedCompanyId = SessionStorageService.getSessionPartnerCompanyIdOfPrimeCompany();
                } else if (isTargetRoleId([USER_ROLES.foreman], roleId)) {
                  selectedCompanyId = SessionStorageService.getCompanyId();
                }

                SessionStorageService.setSessionSelectedPartnerCompanyId(
                  selectedCompanyId
                );
                masterSlideLoader.show('Workers', { state: {} });
              });
            }}
          >
            <div className='icon icon--line-list'>
              <i className='i-workers' aria-hidden='true' />
            </div>
            作業員一覧
            {(hasExpiration || hasInconsistencyStatus) && (
              <WarningIcon color={iconType} />
            )}
          </div>
        </Tippy>
      </div>
    </Auth>
  );
};

/**
 * CSVデータ出力
 * @params useOutputCsvProcessingFlg: true:表示する, false：表示しない
 * */
const OutputCSV = ({ isDisplay, callback }) => {
  return isDisplay ? (
    <Auth approvedRoles={[USER_ROLES.prime, USER_ROLES.branch]}>
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('CsvRequest', {
              state: {},
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-output-csv' aria-hidden='true' />
          </div>
          CSVデータ出力
        </div>
      </div>
    </Auth>
  ) : null;
};

/**
 * 協力会社一覧
 * */
const PartnerCompanies = ({ callback }) => {
  return (
    <Auth
      approvedRoles={[USER_ROLES.prime, USER_ROLES.branch, USER_ROLES.manager]}
    >
      <div className='darklist__item'>
        <div
          className='enable line-list line-list--darklist'
          onClick={() => {
            callback();
            showMasterSlideLoader('PartnerCompanies', {
              state: {},
            });
          }}
        >
          <div className='icon icon--line-list'>
            <i className='i-partner-companies' aria-hidden='true' />
          </div>
          協力会社一覧
        </div>
      </div>
    </Auth>
  );
};

/**
 * 代行先一覧
 * @param className: クラス名
 * */
const AgencyCompanies = ({ className, expirationAgency, callback }) => {
  const hasExpiration = _.some(expirationAgency);
  let expirationText = '';
  let iconType = '';
  let foreignConstructionWorkerText = '';
  if (!_.isUndefined(expirationAgency) && expirationAgency.has_expired) {
    iconType = 'warning';
    expirationText = messageUtility.getMessage('E-001-105');
  } else if (expirationAgency.has_about_to_expire) {
    iconType = 'caution';
    expirationText = messageUtility.getMessage('E-001-106');
  }
  if (expirationAgency.has_foreign_construction_workers) {
    iconType = 'warning';
    foreignConstructionWorkerText = messageUtility.getMessage('E-001-107');
  }

  const renderMessage = () => {
    const messages = [];
    if (expirationText) {
      messages.push(expirationText);
    }
    if (foreignConstructionWorkerText) {
      messages.push(foreignConstructionWorkerText);
    }

    return (
      <div className='darklist__tooltip'>
        {messages.map((message, index) => (
          <React.Fragment key={index}>
            {messages.length > 1 && '・'}
            {message}
            {index < messages.length - 1 && <br />}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <Auth approvedRoles={[USER_ROLES.partner]}>
      <div className='darklist__item'>
        <Tippy
          duration={10}
          distance={24}
          arrow='true'
          arrowType='sharp'
          delay={[50, 100]}
          placement='bottom'
          followCursor={true}
          html={<div className='darklist__tooltip'>{renderMessage()}</div>}
          disable={!hasExpiration}
          popperOptions={VIEWPORT_BOUNDARY}
        >
          <div
            className={className}
            onClick={() => {
              callback();
              showMasterSlideLoader('AgencyCompanies', {
                state: {},
              });
            }}
          >
            <div className='icon icon--line-list'>
              <div className='menu-icon' aria-hidden='true'>
                <AgencyCompaniesIcon />
              </div>
            </div>
            代行先一覧
            {hasExpiration && <WarningIcon color={iconType} />}
          </div>
        </Tippy>
      </div>
    </Auth>
  );
};

const AgencyRegistrationApplications = ({ className, callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.partner]}>
      <div className='darklist__item'>
        <div
          className={className}
          onClick={() => {
            callback();
            showMasterSlideLoader(
              AGENCY_REGISTRATION_APPLICATION_PAGE.LIST.COMPONENT_NAME,
              {
                state: {},
              }
            );
          }}
        >
          <div className='icon icon--line-list'>
            <div className='menu-icon' aria-hidden='true'>
              <AgencyRegistrationApplicationsIcon />
            </div>
          </div>
          {AGENCY_REGISTRATION_APPLICATION_PAGE.LIST.TEXT}
        </div>
      </div>
    </Auth>
  );
};

const AgentOrigins = ({ className, callback }) => {
  return (
    <Auth approvedRoles={[USER_ROLES.partner]}>
      <div className='darklist__item'>
        <div
          className={className}
          onClick={() => {
            callback();
            showMasterSlideLoader(
              AGENCY_REGISTRATION_APPLICATION_PAGE.ORIGINS.COMPONENT_NAME,
              {
                state: {},
              }
            );
          }}
        >
          <div className='icon icon--line-list'>
            <div className='menu-icon' aria-hidden='true'>
              <AgentOriginsIcon />
            </div>
          </div>
          {AGENCY_REGISTRATION_APPLICATION_PAGE.ORIGINS.TEXT}
        </div>
      </div>
    </Auth>
  );
};

/**
 * 通知一覧
 * */
const Notices = ({ callback }) => {
  return (
    <div className='darklist__item'>
      <div
        className='enable line-list line-list--darklist'
        onClick={() => {
          callback();
          showMasterSlideLoader('Notices', {
            state: {},
          });
        }}
      >
        <BellIcon className='icon--2x bell-icon' />
        通知一覧
      </div>
    </div>
  );
};

/**
 * ヘルプセンター
 */
const HelpCenter = props => {
  const { toggleShowHelpCenterDialog } = props;
  return (
    <div className='darklist__item'>
      <div
        className='enable line-list line-list--darklist'
        onClick={() => {
          if (ENV_VARS.REACT_APP_ZENDESK_URL === ZENDESK_URL_NONE) {
            toggleShowHelpCenterDialog();
          } else {
            window.open(
              getZendeskUrl(ENV_VARS.REACT_APP_ZENDESK_URL),
              '_blank'
            );
            // window.open(ENV_VARS.REACT_APP_ZENDESK_URL, '_blank');
          }
        }}
      >
        <div className='icon icon--line-list'>
          <i className='i-manual-contact' aria-hidden='true' />
        </div>
        ヘルプセンター
      </div>
    </div>
  );
};

/**
 * お客様番号
 * */
const CustomerNumber = props => {
  const customerNumber = convertUserIdToCustomerNumber(props.userId);

  return (
    <div className='site-footer__customer-number'>
      お客様番号：{customerNumber}
    </div>
  );
};

/**
 * UserIDをお客様番号(0000-0000形式)に変換する
 * @param {number} user_id
 * @returns {string} お客様番号(不正な場合は空文字）
 */
const convertUserIdToCustomerNumber = userId => {
  const stringUserId = String(userId);
  if (!stringUserId.match(/^[0-9]+$/)) {
    return '';
  }
  const text =
    stringUserId.length < 8 ? stringUserId.padStart(8, '0') : stringUserId;
  const TextCount = text.length;
  return `${text.slice(0, TextCount - 4)}-${text.slice(TextCount - 4)}`;
};

/**
 * コピーライト
 * */
const Copyright = () => {
  return (
    <div className='site-footer__copyright'>
      Copyright © RVSTA, Inc. All Rights Reserved.
    </div>
  );
};

const WarningIcon = props => {
  const { color } = props;
  return (
    <div className={`darklist__warning-icon darklist__warning-icon--${color}`}>
      <i className='icon-warning_round' />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/masterNavi.js